module.exports = "/_next/static/images/4b452862f748f5f4d2158dc61c35b4c6-card-xs.png.webp";